import { NonIdealState } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import * as React from "react";

import { useTl } from "../../hooks/useTl";
import { ETLCodes } from "../../locales/ETLCodes";

interface IUnauthorizedPageProps {}

export const UnauthorizedPage: React.FunctionComponent<
  IUnauthorizedPageProps
> = () => {
  const { t } = useTl();

  return (
    <NonIdealState
      title={t(ETLCodes.ErrorMessage_Unauthorized_title)}
      icon={IconNames.CROSS}
      description={t(ETLCodes.ErrorMessage_Unauthorized)}
    />
  );
};
